import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CountryService} from "../../../../../../core/services/parameters/country.service";
import {PaisesComponent} from "../../paises.component";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<PaisesComponent>,
    private countryService: CountryService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.countryService.deleteCountry(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
